import { atom } from 'recoil';

const ClockOpenState = atom({
    key: 'clockOpenState',
    default: false
});

export default ClockOpenState;